import React from 'react';

const Join = () => {
  return (
    <section id="professionals" className="join section">
      <div className="container">
        <div className="join-card">
          <h2>Join Team Glaminant</h2>
          <p className="join-description">
            We are a modern at-home beauty service brand specializing in luxury experiences.
            We are currently hiring experienced and passionate professionals in waxing, nails, and facials who are committed to quality, hygiene, and client comfort.
          </p>
          <ul className="join-benefits">
            <li>Flexible Work & Independence</li>
            <li>Competitive Pay</li>
            <li>Redefine Beauty Services</li>
            <li>Advanced Training Provided</li>
          </ul>
          <a
            href="https://forms.gle/9Sh3YpRGrmK9Txy17"
            className="btn join-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apply Now
          </a>
          <p className="join-note">We’ll review your details and reach out if there's a good fit.</p>
        </div>
      </div>
    </section>
  );
};

export default Join;